var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 24,
    viewBox: "0 0 68 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.737269 15.6086C0.257269 20.1086 4.43727 20.9836 6.58727 20.8586H7.0392C6.89185 20.3595 6.81277 19.8312 6.81277 19.2844C6.81277 16.2192 9.29759 13.7344 12.3628 13.7344C15.4279 13.7344 17.9128 16.2192 17.9128 19.2844C17.9128 19.8312 17.8337 20.3595 17.6863 20.8586H18.0623L48.4399 20.8586C48.2926 20.3595 48.2135 19.8312 48.2135 19.2844C48.2135 16.2192 50.6983 13.7344 53.7635 13.7344C56.8287 13.7344 59.3135 16.2192 59.3135 19.2844C59.3135 19.8312 59.2344 20.3595 59.0871 20.8586H59.3873C63.0623 20.8586 67.2623 18.3836 67.4123 16.8836C67.5323 15.6836 66.7123 14.9836 66.2873 14.7836C66.3373 13.4586 66.4073 10.5836 66.2873 9.68362C66.1373 8.55862 62.7623 3.30869 59.7623 2.03359C56.7623 0.758492 42.8123 0.833592 34.4123 1.13359C27.6923 1.37359 19.3123 6.38359 15.9623 8.85859C11.0873 9.23359 1.21727 11.1086 0.737269 15.6086ZM22.8631 6.4594C23.6501 7.47512 23.3881 8.6344 22.8631 9.1594L35.7251 8.60012V2.60012C34.6251 2.62512 30.3031 3.3994 22.8631 6.4594ZM37.9382 8.48455V2.48455H46.4882V8.07527L37.9382 8.48455ZM47.9894 4.58497V7.88497H49.7144L47.9894 4.58497ZM51.3624 7.50955L48.8124 2.48455C51.8124 2.50955 57.9474 2.66455 58.4874 3.08455C59.1624 3.60955 61.1874 5.25955 61.0374 6.00955C60.8874 6.75955 60.5124 7.50955 58.8624 7.50955H51.3624Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2879,
    cy: 19.3592,
    r: 3.675,
    stroke: "#BABABA",
    strokeWidth: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6883,
    cy: 19.3592,
    r: 3.675,
    stroke: "#BABABA",
    strokeWidth: 1.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagon);
export default ForwardRef;